
/**
 * 상세 에러 정보
 * @nullable
 */
export type PostApiV1RefundsCancelSubscription400ErrorDetails = { [key: string]: unknown } | null;
